import { createSlice } from "@reduxjs/toolkit";

export const userDataSlice = createSlice({
    name: 'user',
    initialState: {
        value: localStorage.getItem('user_data') ?? {}
    },
    reducers: {
        setUserData: (state, action) => {
            state.value = action.payload;
            localStorage.setItem('user_data', action.payload);
        }
    },
})

export const { setUserData } = userDataSlice.actions;

export default userDataSlice.reducer
